import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

const TooltipText = styled.div`
  position: fixed;
  background-color:rgb(126, 154, 184);   /* Banner-inspired purple */
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.15s, transform 0.1s;
  white-space: nowrap;
  z-index: 1000;
`;

export default function CustomTooltip({ children, content }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setCoords({ x: e.clientX + 10, y: e.clientY + 10 }); // offset a bit from cursor
  };

  const handleMouseEnter = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ display: "inline-block" }}
    >
      {children}

      {ReactDOM.createPortal(
        <TooltipText
          visible={visible}
          style={{
            top: coords.y + "px",
            left: coords.x + "px",
            transform: "translate(0, 0)",
          }}
        >
          {content}
        </TooltipText>,
        document.body
      )}
    </div>
  );
}
